import React , { useEffect, useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { orange } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ApartmentIcon from "@mui/icons-material/Apartment";
import GroupIcon from '@mui/icons-material/Group';
import { IMAGE_URL } from "../services/api";
import {
  PendingActions,
  TodayOutlined,
  ArrowDropDown,
  ArrowDropUp,
  Square,
  MilitaryTech,
  Circle,
  AccessTime,
  CakeSharp,
  Portrait, 
} from "@mui/icons-material"; // Icons
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../styles/styles.css";
import AuthViewController from "../redux/actions/AuthViewController";
import Avatar from "@mui/material/Avatar";
import { format, isToday, isTomorrow, parseISO } from "date-fns";
import { getUserInfoFromToken } from "../utils/authUtils";
import ProtectedImage from "./ProtectedImage";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Dummy data for the dashboard
const data = [
  { name: "Present", value: 59 },
  { name: "Late", value: 21 },
  { name: "Permission", value: 2 },
  { name: "Absent", value: 18 }
];
const COLORS = ["#03c95a", "#3b7080", "#f26522", "#e70d0d"];

// Dummy data for upcoming birthdays
const upcomingBirthdays = [
  { name: "John Doe", birthday: "2025-02-15" },
  { name: "Jane Smith", birthday: "2025-02-20" },
  { name: "Alice Johnson", birthday: "2025-03-05" },
  { name: "Bob Davis", birthday: "2025-03-10" },
  { name: "Sophia Taylor", birthday: "2025-03-18" }
];

const Dashboard = () => {
  // const userType = localStorage.getItem("user_type");
  const dispatch = useDispatch();
   const { getEmployerDashboardData } = AuthViewController();
   const { employerdashboardData } = useSelector((state) => state.auth);
   const [userType, setUserType] = useState(null);
   const [userId, setUserId] = useState(null);
   const navigate = useNavigate();

   useEffect(() => {
       dispatch(getEmployerDashboardData());
     }, [dispatch]);

   const formikRef = useRef();
           useEffect(() => {
           const { userType, userId } = getUserInfoFromToken();
           setUserType(userType);
           setUserId(userId);
         }, []);

   const last4ClockIns = employerdashboardData?.last_4_clock_ins || [];

      const parseTime = (timeStr) => {
      const [hours, minutes, seconds] = timeStr.split(":").map(Number);
      return new Date(1970, 0, 1, hours, minutes, seconds);
    };

    let lateEmployee = null;
    let earlyEmployees = [];

    if (last4ClockIns.length > 0) {
      // Sort by clock_in_time as actual time
      lateEmployee = [...last4ClockIns].sort(
        (a, b) => parseTime(b.clock_in_time) - parseTime(a.clock_in_time)
      )[0];

      earlyEmployees = last4ClockIns.filter((emp) => emp !== lateEmployee);
    }


  
  const data = [
      {
        name: "Present",
        value: employerdashboardData?.present_employees_today || 0,
      },
      {
        name: "Late",
        value: employerdashboardData?.late_employees_today || 0,
      },
      {
        name: "On Leave",
        value: employerdashboardData?.on_leave_today || 0,
      },
      {
        name: "Absent",
        value: employerdashboardData?.absent_employees_today || 0,
      },
    ];

    const total = data.reduce((sum, item) => sum + item.value, 0) || 1; // avoid 0 division
    
   const todayBirthdays = employerdashboardData?.upcoming_birthdays?.filter((item) =>
      isToday(parseISO(item.date_of_birth))
    ) || [];

    const tomorrowBirthdays = employerdashboardData?.upcoming_birthdays?.filter((item) =>
      isTomorrow(parseISO(item.date_of_birth))
    ) || [];

    const futureBirthdays = employerdashboardData?.upcoming_birthdays?.filter((item) =>
      !isToday(parseISO(item.date_of_birth)) &&
      !isTomorrow(parseISO(item.date_of_birth))
    ) || [];

    const combinedBirthdays = [
      ...todayBirthdays.map((item) => ({ ...item, group: 'today' })),
      ...tomorrowBirthdays.map((item) => ({ ...item, group: 'tomorrow' })),
      ...futureBirthdays.map((item) => ({ ...item, group: 'future' })),
    ].slice(0, 4); // Limit to 4

    const hasToday = combinedBirthdays.some((b) => b.group === 'today');
    const hasTomorrow = combinedBirthdays.some((b) => b.group === 'tomorrow');
    const hasFuture = combinedBirthdays.some((b) => b.group === 'future');


  return (
    <div style={{ maxHeight: "100vh" }}>
      
      <Grid container spacing={3}>
        {/* Dashboard Widgets */}
        <Grid item xs={12} sm={6} md={3}>
  <div
    className="card"
    style={{ cursor: userType === "Employer" ? "pointer" : "default" }}
    onClick={() => {
      if (userType === "Employer") {
        navigate("/time-attendance");
      }
    }}
  >
    <div>
      <div className="avatar rounded-circle bg-primary mb-1">
        {userType === "Employer" ? (
          <TodayOutlined className="white-icon" />
        ) : (
          <BusinessOutlinedIcon className="white-icon" />
        )}
      </div>
      <h6 className="fs-13 fw-medium text-default mb-1">
        {userType === "Admin" ? "Companies" : "Attendance"}
      </h6>
      {userType === "Employer" ? (
        <h3 className="value mb-3">
          {employerdashboardData?.present_employees_today || 0} /{" "}
          {employerdashboardData?.total_employees || 0}
          <span className="fs-12 fw-medium text-success ms-2">
            {employerdashboardData?.total_employees
              ? `${(
                  (employerdashboardData.present_employees_today /
                    employerdashboardData.total_employees) *
                  100
                ).toFixed(2)}%`
              : "0%"}
          </span>
        </h3>
      ) : (
        <h3 className="value mb-3">{employerdashboardData?.total_companies || 0}</h3>
      )}
    </div>
  </div>
</Grid>
        <Grid item xs={12} sm={6} md={3}>
  <div
    className="card"
    style={{ cursor: userType === "Employer" ? "pointer" : "default" }}
    onClick={() => {
      if (userType === "Employer") {
        navigate("/users");
      }
    }}
  >
    <div>
      <div className="avatar rounded-circle bg-info mb-1">
        {userType === "Employer" ? (
          <GroupIcon className="white-icon" />
        ) : userType === "Admin" ? (
          <GroupIcon className="white-icon" />
        ) : null}
      </div>

      <h6 className="fs-13 fw-medium text-default mb-1">
        {userType === "Admin" ? "Active Employers" : "Active Employees"}
      </h6>

      <h3 className="value mb-3">
        {userType === "Employer" ? (
          <>
            {employerdashboardData?.active_employees || 0} / {employerdashboardData?.total_employees || 0}
            <span className="fs-12 fw-medium text-success ms-2">
              {employerdashboardData?.total_employees
                ? `${(
                    (employerdashboardData.active_employees / employerdashboardData.total_employees) *
                    100
                  ).toFixed(2)}%`
                : "0%"}
            </span>
          </>
        ) : (
          <>
            {employerdashboardData?.total_active_employer || 0}/{employerdashboardData?.total_employer || 0}
          </>
        )}
      </h3>
    </div>
  </div>
</Grid>
        <Grid item xs={12} sm={6} md={3}>
  <div
    className="card"
    style={{ cursor: userType === "Employer" ? "pointer" : "default" }}
    onClick={() => {
      if (userType === "Employer") {
        navigate("/departments");
      }
    }}
  >
    <div>
      <div className="avatar rounded-circle bg-primary mb-1">
        {userType === "Admin" ? (
          <ApartmentIcon className="white-icon" />
        ) : userType === "Employer" ? (
          <Portrait className="white-icon" />
        ) : null}
      </div>

      <h6 className="fs-13 fw-medium text-default mb-1">Departments</h6>

      <h3 className="value mb-3">
        {userType === "Employer" ? (
          <>
            {employerdashboardData?.total_departments || 0}
            <span className="fs-12 fw-medium text-success ms-2">
              {/* Optional: additional info */}
            </span>
          </>
        ) : (
          employerdashboardData?.total_department || 0
        )}
      </h3>
    </div>
  </div>
</Grid>

        <Grid item xs={12} sm={6} md={3}>
  <div
    className="card"
    style={{ cursor: userType === "Employer" ? "pointer" : "default" }}
    onClick={() => {
      if (userType === "Employer") {
        navigate("/leaves");
      }
    }}
  >
    <div>
      <div className="avatar rounded-circle bg-danger mb-1">
        {userType === "Employer" ? (
          <PendingActions className="white-icon" />
        ) : userType === "Admin" ? (
          <Portrait className="white-icon" />
        ) : null}
      </div>

      <h6 className="fs-13 fw-medium text-default mb-1">
        {userType === "Admin" ? "Active Employees" : "Pending Requests"}
      </h6>

      {userType === "Employer" ? (
        <h3 className="value mb-3">
          {employerdashboardData?.pending_leave_requests || 0} / {employerdashboardData?.total_leave_requests || 0}
          <span className="fs-12 fw-medium text-success ms-2">
            {employerdashboardData?.total_leave_requests
              ? `${(
                  (employerdashboardData.pending_leave_requests / employerdashboardData.total_leave_requests) *
                  100
                ).toFixed(2)}%`
              : "0%"}
          </span>
        </h3>
      ) : userType === "Admin" ? (
        <h3 className="value mb-3">
          {employerdashboardData?.total_active_employee || 0}/{employerdashboardData?.total_employee || 0}
        </h3>
      ) : null}
    </div>
  </div>
</Grid>
        {/* Pending Leave Approvals Widget */}
      </Grid>

      {userType === 'Employer' && (
       <>
      <Row>
        <Col>
          <div className="card">
            <div style={{ width: "100%" }}>
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap mb-2">
                <h5 className="mb-1">Employee Status</h5>
              </div>
              <div className="d-flex align-items-center justify-content-between ">
                <p className="fs-13 mb-2">Total Employee</p>
                <h3 className="mb-2">{employerdashboardData?.total_employees|| 0}</h3>
              </div>
              <Row className="border-top">
                <Col className="p-0">
                  <div className="p-2 flex-fill border-end border-bottom">
                    <p className="fs-13 mb-2">
                      <Square className="fs-12 text-primary " /> Fulltime{" "}
                      <span className="text-gray-9">
                         (
                          {employerdashboardData?.employee_status_summary?.["Full Time"]?.percentage || 0}
                         %)
                      </span>
                    </p>
                    <h2 className="display-1">
                      {employerdashboardData?.employee_status_summary?.["Full Time"]?.["full-time-count"] || 0}
                    </h2>
                  </div>
                </Col>
                <Col className="p-0">
                  <div className="p-2 flex-fill border-bottom text-end">
                    <p className="fs-13 mb-2">
                      <Square className="fs-12 text-secondary " /> Contract{" "}
                      <span className="text-gray-9">
                         (
                          {employerdashboardData?.employee_status_summary?.["Contract"]?.percentage || 0}
                         %)
                      </span>
                    </p>
                    <h2 className="display-1">
                      {employerdashboardData?.employee_status_summary?.["Contract"]?.["contract-count"] || 0}
                    </h2>
                  </div>
                </Col>
              </Row>
              <Row className="border-bottom mb-3">
                <Col className="p-0">
                  {" "}
                  <div className="p-2 flex-fill border-end">
                    <p className="fs-13 mb-2">
                      <Square className="fs-12 text-danger" /> Probation{" "}
                      <span className="text-gray-9">
                         (
                          {employerdashboardData?.employee_status_summary?.["Probation"]?.percentage || 0}
                         %)
                      </span>
                    </p>
                    <h2 className="display-1">
                      {employerdashboardData?.employee_status_summary?.["Probation"]?.["probation-count"] || 0}
                    </h2>
                  </div>
                </Col>
                <Col className="p-0">
                  {" "}
                  <div className="p-2 flex-fill text-end ">
                    <p className="fs-13 mb-2">
                      <Square className="fs-12 text-pink" /> WFH{" "}
                      <span className="text-gray-9">
                        (
                          {employerdashboardData?.employee_status_summary?.["Work From Home"]?.percentage || 0}
                         %)
                      </span>
                    </p>
                    <h2 className="display-1">
                      {employerdashboardData?.employee_status_summary?.["Work From Home"]?.["wfh-count"] || 0}
                    </h2>
                  </div>
                </Col>
              </Row>
              <h6 className="mb-2">Top Performer</h6>
              <div className="p-2 d-flex align-items-center justify-content-between border border-primary bg-primary-100 br-5 mb-4">
                <div className="d-flex align-items-center overflow-hidden">
                  <MilitaryTech className=" text-primary fs-24" />
                  <a className="avatar avatar-md me-2">
                    <ProtectedImage
  path="https://smarthr.dreamstechnologies.com/react/template/assets/img/profiles/avatar-24.jpg"
  alt="Profile"
  className="rounded-circle border border-white"
/>
                  </a>
                  <div>
                    <h6 className="text-truncate mb-1 fs-14 fw-medium">
                      Daniel Esbella
                    </h6>
                    <p className="fs-13">IOS Developer</p>
                  </div>
                </div>
                <div className="text-end">
                  <p className="fs-13 mb-1">Performance</p>
                  <h5 className="text-primary">99%</h5>
                </div>
              </div>
             <Link to="/users" className="btn btn-light btn-md w-100">
              View All Employees
            </Link>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card">
            <div style={{ width: "100%" }}>
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-1">Attendance Overviews</h5>
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <PieChart width={200} height={200}>
                  {/* The Pie with a start angle of 180 degrees for a half-pie chart */}
                  <Pie
                    data={data}
                    cx="50%" // Center X of the pie chart
                    cy="50%" // Center Y of the pie chart
                    innerRadius={40} // Inner radius for a donut shape
                    outerRadius={80} // Outer radius for the full circle
                    dataKey="value" // Use the "value" field from data
                    paddingAngle={5} // Adds some spacing between the segments
                  >
                    {data.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  {/* <Legend /> */}
                </PieChart>
              </div>
              <h6 className="mb-2">Status</h6>
              <div className="d-flex align-items-center justify-content-between">
                <p className="f-13 mb-2">
                  <Circle className="text-success me-1" /> Present
                </p>
                <p className="f-13 fw-medium text-gray-9 mb-2">
                  {((data[0].value / total) * 100).toFixed(0)}%
                </p>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <p className="f-13 mb-2">
                  <Circle className="text-secondary me-1" /> Late
                </p>
                <p className="f-13 fw-medium text-gray-9 mb-2">
                  {((data[1].value / total) * 100).toFixed(0)}%
                </p>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <p className="f-13 mb-2">
                  <Circle className="text-warning me-1" /> On Leave
                </p>
                <p className="f-13 fw-medium text-gray-9 mb-2">
                  {((data[2].value / total) * 100).toFixed(0)}%
                </p>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <p className="f-13 mb-2">
                  <Circle className="text-danger me-1" /> Absent
                </p>
                <p className="f-13 fw-medium text-gray-9 mb-2">
                  {((data[3].value / total) * 100).toFixed(0)}%
                </p>
              </div>
              <Link to="/time-attendance" className="btn btn-light btn-md w-100">
               View All Absent Employees
            </Link>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
       <Col xs={12} md={6} className="mb-3">
        <div className="card" style={{ height: "460px" }}>
          <div style={{ width: "100%" }}>
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap mb-3">
              <h5 className="mb-1">Clock-In/Out</h5>
            </div>

            {/* Regular (non-late) Employees */}
            {earlyEmployees.map((emp, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between mb-3 p-2 border border-dashed br-5"
              >
                <div className="d-flex align-items-center">
                  <Avatar
              sx={{ width: 50, height: 50, bgcolor: "primary.dark", border: "2px solid #ddd" }}
            >
              <ProtectedImage
                path={emp.profile_image}           
                alt={emp.name || "Profile"}        
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </Avatar>

                  <div className="ms-2">
                    <h6 className="fs-14 fw-medium text-truncate mb-0">{emp.name}</h6>
                    <p className="fs-13">{emp.designation}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <a className="link-default me-2">
                    <AccessTime />
                  </a>
                  <span className="fs-10 fw-medium d-inline-flex align-items-center badge badge-success">
                    <Circle className="fs-5 me-1 white-icon" />
                    {emp.clock_in_time?.slice(0, 5)}
                  </span>
                </div>
              </div>
            ))}

            {/* Late Section */}
            <h6 className="mb-2">Late</h6>
            {lateEmployee && (
              <div className="d-flex align-items-center justify-content-between mb-3 p-2 border border-dashed br-5">
                <div className="d-flex align-items-center">
                  <Avatar
  sx={{ width: 48, height: 48, border: "2px solid #ddd", bgcolor: "primary.dark" }}
>
  <ProtectedImage
    path={lateEmployee.profile_image}        
    alt={lateEmployee.name || "Profile"}     
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />
</Avatar>

                  <div className="ms-2">
                    <h6 className="fs-14 fw-medium text-truncate mb-0">
                      {lateEmployee.name}
                    </h6>
                    <p className="fs-13">{lateEmployee.designation}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <a className="link-default me-2">
                    <AccessTime />
                  </a>
                  <span className="fs-10 fw-medium d-inline-flex align-items-center badge badge-success">
                    <Circle className="fs-5 me-1 white-icon" />
                    {lateEmployee.clock_in_time?.slice(0, 5)}
                  </span>
                </div>
              </div>
            )}

            <Link to="/time-attendance" className="btn btn-light btn-md w-100">
               View All 
            </Link>
          </div>
        </div>
      </Col>

       <Col xs={12} md={6} className="mb-3">
  <div className="card" style={{ height: "460px" }}>
    <div style={{ width: "100%", height: "100%" }}>
      <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap mb-2">
        <h5 className="mb-1">Upcoming Birthday</h5>
      </div>

      {combinedBirthdays.length > 0 &&
      (hasToday || hasTomorrow || hasFuture) ? (
        <>
          {hasToday && (
            <>
              <h6 className="mb-2">Today</h6>
              {combinedBirthdays
                .filter((item) => item.group === "today")
                .map((item, index) => (
                  <div
                    key={`today-${index}`}
                    className="bg-light p-2 border border-dashed rounded-top mb-3"
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <Avatar
  sx={{ width: 48, height: 48, border: "2px solid #ddd", bgcolor: "primary.dark" }}
>
  <ProtectedImage
    path={item.profile_image}         
    alt={item.name || "Profile"}     
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />
</Avatar>
                        <div className="ms-2">
                          <h6 className="fs-14 fw-medium text-truncate mb-0 text-dark">{item.name}</h6>
                          <p className="fs-13">{item.designation}</p>
                        </div>
                      </div>
                      <a className="btn btn-secondary btn-xs d-flex align-items-center">
                        <CakeSharp className="fs-11" />
                        Send
                      </a>
                    </div>
                  </div>
                ))}
            </>
          )}

          {hasTomorrow && (
            <>
              <h6 className="mb-2">Tomorrow</h6>
              {combinedBirthdays
                .filter((item) => item.group === "tomorrow")
                .map((item, index) => (
                  <div
                    key={`tomorrow-${index}`}
                    className="bg-light p-2 border border-dashed rounded-top mb-2"
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                       <Avatar
  sx={{ width: 48, height: 48, border: "2px solid #ddd", bgcolor: "primary.dark" }}
>
  <ProtectedImage
    path={item.profile_image}          
    alt={item.name || "Profile"}       
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",            
    }}
  />
</Avatar>
                        <div className="ms-2">
                          <h6 className="fs-14 fw-medium text-truncate mb-0 text-dark">{item.name}</h6>
                          <p className="fs-13">{item.designation}</p>
                        </div>
                      </div>
                      <a className="btn btn-secondary btn-xs d-flex align-items-center">
                        <CakeSharp className="fs-11" />
                        Send
                      </a>
                    </div>
                  </div>
                ))}
            </>
          )}

          {hasFuture && (
            <>
              {combinedBirthdays
                .filter((item) => item.group === "future")
                .map((item, index) => (
                  <div key={`future-${index}`}>
                    <h6 className="mb-1">
                      {format(parseISO(item.date_of_birth), "dd MMM yyyy")}
                    </h6>
                    <div className="bg-light p-2 border border-dashed rounded-top mb-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <Avatar
  sx={{ width: 48, height: 48, border: "2px solid #ddd", bgcolor: "primary.dark" }}
>
  <ProtectedImage
    path={item.profile_image}          
    alt={item.name || "Profile"}       
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",             
    }}
  />
</Avatar>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-0 text-dark">{item.name}</h6>
                            <p className="fs-13">{item.designation}</p>
                          </div>
                        </div>
                        <a className="btn btn-secondary btn-xs d-flex align-items-center">
                          <CakeSharp className="fs-11" />
                          Send
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
            </>
          )}
        </>
      ) : (
        <div className="text-center text-muted py-4">No Upcoming Birthday</div>
      )}
    </div>
  </div>
</Col>

      </Row>
      </> )}
    </div>
  );
};

export default Dashboard;
